export const getSchoolDisplayName = (schools: { name: string }[]): string => {
  if (schools.length > 1) return 'My Schools';
  if (schools.length > 0) return schools[0].name;
  return '';
};
